// Heading comparison key — shared by spec-assemble (merge rule) and
// module-updates (merged-heading suppression). Kept tiny and import-free so
// the server bundle stays small.

/** Trim, collapse whitespace, uppercase, strip a leading "3.2 " / "A. "
 *  prefix, strip trailing punctuation. Exact match after that. */
export function normalizeHeading(text: string): string {
  let t = (text || '').replace(/\s+/g, ' ').trim().toUpperCase();
  // "3.2 ", "1.01 ", "A. ", "A) ", "(a) " — a number label (dots optional) or a
  // single letter that carries its own "." / ")" — then a space.
  t = t.replace(/^(?:\(?(?:\d+(?:\.\d+)*[.)]?|[A-Z][.)])\)?)\s+(?=\S)/, '');
  t = t.replace(/[\s.:;,\-–—]+$/, '');
  return t.trim();
}
